module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/branches_settings/branches_settings-show/branches_settings-show.component.scss
// module id = ./src/app/views/setting/branches_settings/branches_settings-show/branches_settings-show.component.scss
// module chunks = main